module.exports = "/_next/static/images/5f0f3ec21d0ddc8e6d10e77781f7dc6e-nubanker-pm@3x.jpg";